/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { memo, useMemo } from "react";
import EventSummary from "./EventSummary";
import Errors from "../../../Components/Errors";

const SYSTEM_EVENTS = [
  "runtime:start",
  "runtime:end",
  "message:reply",
  "outbound-delivery-status",
  "milestone",
  "form-render",
  "form-submitted",
  "form-accessed",
  "component:package",
];

function WorkflowSummary({ state, node, engine, addChild }) {
  const visibleEvents = useMemo(
    () =>
      SYSTEM_EVENTS.filter((item) =>
        state.EventListeners?.some((listener) => listener.EventType === item)
      ),
    [state.EventListeners]
  );

  if (state.EventListeners?.length) {
    return (
      <>
        <Errors
          filterFn={(e) =>
            e.workflow?.UUID === state.UUID && !e.eventListener?.UUID
          }
        />
        {visibleEvents.map((event) => (
          <EventSummary
            key={event}
            state={state}
            event={event}
            node={node}
            engine={engine}
            addChild={addChild}
          />
        ))}
      </>
    );
  }
  return (
    <Errors
      filterFn={(e) => e.workflow?.UUID === state.UUID && !e.eventListener?.UUID}
    />
  );
}

export default memo(WorkflowSummary);
